<template>
  <button
    :class="{ 'pb-float-button': true, [latlng]: true, [color]: true, fab }"
    :title="title"
    @click="$emit('click')"
    :style="multiverse"
  >
    <slot />
  </button>
</template>
<script>
import { FLOAT_POSITION_LIST, FLOAT_POSITION } from "@/lib/staticValue.js";

export default {
  name: "PbFloatButton",
  data: () => ({}),
  props: {
    color: {
      type: String, // "error" | "success" | "warn" | "disabled" | "info" | "black-reverse",
      default: () => "disabled",
    },
    position: String,
    title: String,
    fab: Boolean,
    vertical: Boolean,
    horizontal: Boolean,
    index: String,
  },
  computed: {
    multiverse() {
      const idx = parseInt(this.index);

      if (this.horizontal) {
        return `transform: translateY(calc((-5.8rem - 16px) * ${idx}));`;
      }

      if (this.vertical) {
        return `transform: translateX(calc((-5.8rem - 16px) * ${idx}));`;
      }

      return "";
    },
    latlng() {
      let pos = this.position;
      const check = FLOAT_POSITION_LIST.findIndex(
        (pos) => pos === this.position
      );

      if (check === -1) {
        pos = "BOTTOM_RIGHT";
      }

      return FLOAT_POSITION[pos];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/color";

.pb-float-button {
  position: fixed;
  border: none;

  background-color: #242424;
  color: #ffffff;
  width: 5.8rem;
  height: 5.8rem;
  font-size: 1.8rem;
  box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.2);
  outline: none;
  cursor: pointer;

  &.fab {
    border-radius: 50%;
  }

  &.top {
    top: calc(2.4vh + 16px);
  }

  &.bottom {
    bottom: calc(2.4vh + 16px);
  }

  &.left {
    left: calc(1.6vw + 16px);
  }

  &.right {
    right: calc(1.6vw + 16px);
  }

  &.center {
    left: 50%;
    transform: translateX(-50%);
  }

  &.error {
    @extend %error_setting;
  }

  &.success {
    @extend %success_setting;
  }

  &.info {
    @extend %info_setting;
  }

  &.warn {
    @extend %warn_setting;
  }

  &.primary {
    @extend %primary_setting;
  }

  &.ghost {
    background-color: transparent !important;
    color: #242424 !important;
    border: none;
  }
}
</style>
